var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 15,
  viewBox: "0 0 12 15"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "always-recording-low-power",
  transform: "translate(-4 -2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_44176",
  "data-name": "Path 44176",
  d: "M13.75,6.2V5a3.009,3.009,0,0,0-3-3H7A3.009,3.009,0,0,0,4,5v9a3.009,3.009,0,0,0,3,3h6a3.009,3.009,0,0,0,3-3V8.75a.681.681,0,0,0-.225-.525ZM14.5,14A1.5,1.5,0,0,1,13,15.5H7A1.5,1.5,0,0,1,5.5,14V5A1.5,1.5,0,0,1,7,3.5h3.75A1.5,1.5,0,0,1,12.25,5V6.5a.681.681,0,0,0,.225.525L14.5,9.05Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44177",
  "data-name": "Path 44177",
  d: "M7.75,5A.709.709,0,0,0,7,5.75V6.5a.709.709,0,0,0,.75.75A.709.709,0,0,0,8.5,6.5V5.75A.709.709,0,0,0,7.75,5ZM10,5a.709.709,0,0,0-.75.75V6.5a.75.75,0,0,0,1.5,0V5.75A.709.709,0,0,0,10,5Z",
  transform: "translate(-0.75 -0.75)"
}))));

export default __webpack_public_path__ + "static/media/always-recording-low-power.9a6ab695.svg";
export { SvgComponent as ReactComponent };